import React from "react";
import styled from "styled-components";
import InlineSVG from "svg-inline-react";
import { fbIcon, igIcon, inIcon } from "../assets/svg";
import { RollFromBottom } from "../ui/animations";
import posed from "react-pose";

const TeamBoxContainer = styled.div`
  margin: 80px 35px;
  @media (max-width: 600px) {
    margin: 30px 15px;
  }
  h3 {
    font-family: Fira Sans;
    font-weight: 900;
    font-size: 25px;
    color: #fff;
    margin-bottom: 0;
  }
  p {
    margin: 0;
    font-family: "Roboto";
    line-height: 29px;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.6);
  }
  &:nth-child(even) {
    > div {
      border-bottom: 15px solid #fff;
    }
  }
  /* &:nth-child(odd) {
    > div {
      border-top: 15px solid #fff;
    }
  } */
`;

const ImageContainer = styled.div`
  position: relative;
  width: 285px;
  height: 405px;
  background: url(${({ picture }) => picture || ""});
  background-size: cover;
  background-position: center;
  -moz-filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
  -o-filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
  -webkit-filter: grayscale(100%);
  z-index: 20;
  filter: gray;
  filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
  :hover > div {
    opacity: 1;
  }
  :focus > div {
    opacity: 1;
  }
`;

const InfoContainer = styled.div`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  p {
    font-family: "Roboto";
    line-height: 25px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
    width: 80%;
  }
  .icons {
    display: flex;
    justify-content: flex-start;
    width: 80%;
    svg {
      padding: 30px 15px 15px 0;
    }
  }
`;

const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  animation: ${RollFromBottom} 1.75s ease;
`;

const Item = posed(ImageContainer)({
  open: {
    transition: ({ i }) => ({ delay: i * 175, ease: "easeOut" }),
    x: 0,
    opacity: 1
  },
  closed: { x: -100, opacity: 0 }
});

const TeamBox = props => {
  return (
    <TeamBoxContainer {...props}>
      <Item {...props} picture={props.person.picture}>
        <InfoContainer>
          <p>{props.person.info}</p>
          <div className="icons">
            <a href={props.person.social.in} target="_blank" rel="noopener noreferrer" >
              <InlineSVG src={inIcon} />
            </a>
            {/* instagram and facebook links removed for team
            <a href={props.person.social.fb}>
              <InlineSVG src={fbIcon} />
            </a>
            <a href={props.person.social.ig}>
              <InlineSVG src={igIcon} />
            </a>
            */}
          </div>
        </InfoContainer>
      </Item>
      <NameContainer>
        <h3>{props.person.name}</h3>
        <p>{props.person.position}</p>
      </NameContainer>
    </TeamBoxContainer>
  );
};

export default TeamBox;
